/* Ott-common */
import { ClientType } from '@dtvgo/backend-service/normalize';
import { Platform as AemPlatform } from '@dtvgo/aem-service';

/* Utils */
import {
  isVegaOS,
  getDeviceInfo,
  changeBackButtonActions,
  closeApp,
} from './general';
import {
  Platform,
  MsToWaitOnReconnection,
  DrmKeySystem,
} from '../../constants';

import {
  PLAY_PAUSE,
  REWIND,
  FAST_FORWARD,
  BACK,
} from './keyCodes';

function init() {
  changeBackButtonActions();
}

export default {
  osName: 'VEGAOS',
  platformName: 'VegaOS',
  appName: 'vega_os',
  aemPlatform: AemPlatform.VEGAOS, // Review needed - change to AemPlatform.VEGAOS when available
  clientType: ClientType.FIRE,
  isThisPlatform: isVegaOS,
  init,
  // App and device info
  getDeviceInfo,
  // Functions
  closeApp,
  sendAppToBackground: closeApp,
  msToWaitOnReconnection: MsToWaitOnReconnection[Platform.VEGAOS],
  // Player related options
  isPlayreadyUtf8AndPlain: true,
  // DRM Preference
  drmKeySystem: DrmKeySystem.WIDEVINE,
  // NPAW
  npaw: {
    name: 'VegaOS',
  },
  // Key codes
  keyCodes: {
    back: BACK,
    mediaControl: {
      playPause: PLAY_PAUSE,
      rewind: REWIND,
      fastForward: FAST_FORWARD,
    },
  },
};
